import { render } from "./ProjectItemLicense.vue?vue&type=template&id=253c3197"
import script from "./ProjectItemLicense.vue?vue&type=script&lang=js"
export * from "./ProjectItemLicense.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__